import { makeStyles } from '@material-ui/core/styles';
import { hSpacing } from 'src/common/helpers/config';

interface BottomBarStyleProps {
  leftHanded: boolean;
}

export const styles = makeStyles(() => ({
  bottomBarContainer: {
    flexDirection: ({ leftHanded }: BottomBarStyleProps) => (leftHanded ? 'row-reverse' : 'row'),
    flexWrap: 'nowrap',
  },
  checkoutButtonItem: {
    alignSelf: 'center',
  },
  pluMenuContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flex: '1 1 auto',
    marginLeft: ({ leftHanded }: BottomBarStyleProps) => (!leftHanded ? hSpacing : 0),
    marginRight: ({ leftHanded }: BottomBarStyleProps) => (leftHanded ? hSpacing : 0),
    overflow: 'hidden',
    '& > div': {
      overflow: 'hidden',
    },
  },
  pluMenu: {
    flex: '1 0 auto',
  },
}));
